export { default } from "./select-paginated";
export { type IProps as ISelectPaginatedProps } from "./select-paginated.types";
